import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Switch, Table, Tooltip } from "antd";
import {
  PlusOutlined,
  AuditOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
// import AddCommissaryDrawer from "./AddCommissaryDrawer";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { NotificationInfo, UserInfo } from "../../../context";
import AddProductOrders from "./AddProductOrders";
import ViewProductConsumption from "./ViewProductConsumption";
import EditProduct from "./EditProduct";
import ProductInfo from "./ProductInfo";

// const defaultExpandable = {
//   expandedRowRender: (record) => <p>{record.description}</p>,
// };

const CommissaryProducts = () => {
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const [categoryList, setCategoryList] = useState({ data: [], ready: false });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedTab, setSelectedTab] = useState("list");
  const [editDrawer, setEditDrawer] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      render: (text) => (
        <Switch
          onChange={() => onChangeProdStatus(parseInt(text.status), text.id)}
          checked={Boolean(parseInt(text.status))}
          size="small"
        />
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Price",
      dataIndex: "price",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
            color: Boolean(parseInt(text)) ? "green" : "red",
          }}
        >
          {Boolean(parseInt(text)) ? "Available" : "Unavailable"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 120 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>

          <Tooltip title="Consumption details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const onChangeProdStatus = (status, id) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", id);
    formdata.append("status", parseInt(status) === 1 ? 0 : 1);
    // setLoadings(true);
    axios
      .post("user/commissary/update-status-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated product successfully.");
          getProductList();
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getAllProductCategory = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/product-category-list", { params })
      .then((response) => {
        const data = response.data;
        setCategoryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
    getAllProductCategory();
  }, [getProductList, getAllProductCategory]);

  const searchable = productList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <CommissaryLayout>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                placeholder="Search product"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
            >
              Add Product
            </Button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.id}
            />
          </div>
        </>
      )}
      {selectedTab === "form" && (
        <AddProductOrders
          close={() => setSelectedTab("list")}
          getProductList={() => getProductList()}
          categoryList={categoryList}
        />
      )}

      {openDrawer && (
        <ViewProductConsumption
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          // setLoading={setLoading}
          // getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
          selectedData={selectedData}
        />
      )}

      {productInfoDrawer && (
        <ProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
          module={"commissary"}
          rerun={() => getProductList()}
        />
      )}

      {editDrawer && (
        <EditProduct
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getProductList={() => getProductList()}
          selectedData={selectedData}
          categoryList={categoryList}
        />
      )}
    </CommissaryLayout>
  );
};

export default CommissaryProducts;
